/**
 * Directive to set the correct icon based on file extension
 * @author Heino Lenting
 */
/**
 * Directive used for displaying the right file icon
 */
var FileIconDirective = /** @class */ (function () {
    function FileIconDirective() {
        // List of icon vs content type mapping
        this.icons = {
            'file': [],
            'archive': ['application/zip'],
            'audio': ['audio/mpeg'],
            'code': ['application/json'],
            'excel': ['application/excel'],
            'image': ['image/png', 'image/jpeg', 'image/gif'],
            'movie': ['video/mp4'],
            'pdf': ['application/pdf'],
            'powerpoint': ['application/vnd.ms-powerpoint'],
            'text': ['text/plain'],
            'word': ['application/msword']
        };
    }
    Object.defineProperty(FileIconDirective.prototype, "fileIcon", {
        /**
         * Set the file icon based on content type
         * @param contentType The content type
         */
        set: function (contentType) {
            var _this = this;
            // Variable for holding class information
            var iconClass;
            // Run through icons the find the content type
            Object.keys(this.icons).forEach(function (icon) {
                if (_this.icons[icon].indexOf(contentType) > -1) {
                    iconClass = 'icon sym-icon-' + icon;
                    return;
                }
            });
            // If content type is not found, use the fallback
            if (!iconClass) {
                iconClass = 'icon sym-icon-file';
            }
            // Set icon class
            this.iconClass = iconClass;
        },
        enumerable: true,
        configurable: true
    });
    return FileIconDirective;
}());
export { FileIconDirective };
